module.exports = __webpack_public_path__ + "static/media/keyman-db-banner.003f41c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyman-db-banner.png
// module id = 1290
// module chunks = 1